'use client';

import { CheckableColorVariantsElementProps } from '@/interfaces/basicForm';

export const ProductColorVariants = ({ name, value, className = '', checked, setChecked, largeSize }: CheckableColorVariantsElementProps) => {
  return (
    <label
      title={name}
      className={`checkbox color-checkbox cursor-pointer flex-col overflow-hidden rounded-full duration-700 hover:scale-110 ${
        checked === value
          ? 'checked shadow-[0_1px_5px_rgb(0_0_0/50%),0_0_0_1px_rgb(0_0_0/5%)]'
          : 'shadow-[0_1px_5px_rgb(0_0_0/20%),0_0_0_1px_rgb(0_0_0/5%)]'
      } ${className}`}
    >
      <input type="checkbox" className="hidden" {...{ name, value }} onChange={(e) => setChecked(value)} />
      <span
        className={`mx-auto mb-0 aspect-square w-5 rounded-[inherit] duration-700`}
        style={{ backgroundColor: value?.toLowerCase().includes('#ffffff') && checked !== value ? '#f0f0f0' : value }}
      ></span>
    </label>
  );
};
